import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const DeliveryOptionsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const BorderedContainer = styled('div')<{ missingInfo?: boolean }>(
  ({ theme, missingInfo }) => ({
    borderRadius: '10px',
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    borderColor: missingInfo ? '#FF0000' : '#EAEAEA',
    borderWidth: missingInfo ? '2px' : '1px',
    borderStyle: 'solid',
  }),
);

export const AddressContainer = styled('label')(({ theme }) => ({
  display: 'flex',
  padding: '16px 16px 12px',
  gap: '8px',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid #EAEAEA',
  cursor: 'pointer',
  ':last-child': {
    borderBottom: 'none !important',
  },
  [theme.breakpoints.up('sm')]: {
    gap: '16px',
    padding: '16px',
  },
}));

export const AddressLeftContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'center',
  minWidth: 0,
});

export const AddressInput = styled('input')({
  cursor: 'pointer',
  WebkitAppearance: 'none',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  outline: 'none',
  border: '2px solid #0277BD',
  minWidth: '24px',
  ':before': {
    content: '""',
    display: 'block',
    width: '60%',
    height: '60%',
    margin: '20% auto',
    borderRadius: '50%',
  },
  ':checked:before': {
    backgroundColor: '#0277BD',
  },
});

export const AddressTypographyDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: '0',
});

export const AddressTypographyTitle = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0.15px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const AddressTypographySubTitle = styled(Typography)({
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0.15px',
  color: '#919191',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const DeliveryPriceContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  minWidth: '42px',
  flexDirection: 'column',
  gap: '4px',
});

export const DeliveryPriceOldContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  textDecoration: 'line-through',
  color: theme.palette.text.secondary,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0.15px',
  marginRight: '8px',
}));

export const DeliveryPriceTypography = styled(Typography)({
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '100%',
  letterSpacing: '0.15px',
});
